module.exports = __webpack_public_path__ + "img/13.f57b6630.jpg";